import {
  SET_IS_SUBMIT_BUTTON,
} from 'store/actions/actionTypes';

export const setIsSubmitButton = (isSubmit: boolean) => ({
  type: SET_IS_SUBMIT_BUTTON,
  payload: isSubmit,
});

export default setIsSubmitButton;